import React from 'react';
import { Hero } from '../components/Hero';
import { ResultsSection } from '../components/ResultsSection';
import { ComparisonChart } from '../components/ComparisonChart';
import { CostComparisonChart } from '../components/CostComparisonChart';
import { SetupGrid } from '../components/SetupGrid';
import { ProcessSection } from '../components/ProcessSection';
import { SocialProof } from '../components/SocialProof';
import { InvestmentSection } from '../components/InvestmentSection';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function CaseStudyPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-210">
      <Hero data-id="element-211" />
      <ResultsSection data-id="element-212" />
      <ComparisonChart data-id="element-213" />
      <CostComparisonChart data-id="element-214" />
      <SetupGrid data-id="element-215" />
      <ProcessSection data-id="element-216" />
      <SocialProof data-id="element-217" />
      <InvestmentSection data-id="element-218" />
      <FAQ data-id="element-219" />
      <FinalCTA data-id="element-220" />
      <Footer data-id="element-221" />
    </div>;
}